import React, { useContext, useEffect } from 'react';
import useClickStreamEvent from 'utils/clickstream/useClickStreamEvent';
import { RecommendationCardProps } from 'views/Questions/components/RecommendationCard/RecommendationCard.types';
import { appAuthContext } from 'context/AuthContext';
import styles from './RecommendationCard.module.css';

const RecommendationCard = ({ data, userParallel }: RecommendationCardProps) => {
  const { sendEvent } = useClickStreamEvent();
  const { user } = useContext(appAuthContext);

  const recommendationGrade =
    data && userParallel && userParallel in data && user ? userParallel : 0;
  const showDefaultRecBlock =
    data === null ||
    (!data[recommendationGrade]?.text && !data[recommendationGrade]?.link);

  const sendClickEvent = () => {
    sendEvent({
      eventType: 'click',
      eventInfo: 'otvety_recommendation_block',
    });
  };

  useEffect(() => {
    sendEvent({
      eventType: 'display',
      eventInfo: 'otvety_recommendation_block',
    });
  }, []);

  return (
    <article className={styles.recommendation}>
      <div className={styles.recommendation__user}>
        <div className={styles.recommendation__avatar} />
        <div className={styles.recommendation__name}>Рекомендации Учи.Ответов</div>
        <div className={styles.recommendation__discount}>УЧИ.РУ</div>
      </div>
      <div className={styles.recommendation__text}>
        {showDefaultRecBlock
          ? 'Разобраться в сложных темах по школьным предметам помогут курсы Учи.ру'
          : data[recommendationGrade].text}
      </div>
      <a
        onClick={sendClickEvent}
        href={
          showDefaultRecBlock
            ? 'https://uchi.ru/profile/students'
            : data[recommendationGrade].link
        }
        target="_blank"
        className={styles.recommendation__link}
        rel="noopener"
      >
        {showDefaultRecBlock ? 'Заниматься' : 'Открыть'}
      </a>
    </article>
  );
};

export default RecommendationCard;
